import React from 'react';
import PropTypes from 'prop-types';

const Contents = ({ color, width, height, ariaLabel }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    aria-labelledby="title"
  >
    <title id="title">{ariaLabel}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" />
      <path
        fill={color}
        d="M12.967 10.304l.068.085c.182.266.155.62-.069.86-.257.275-.657.275-.915 0-1.21-1.294-3.133-1.353-4.401-.14l-.137.14-3.272 3.498c-1.265 1.353-1.265 3.532 0 4.885 1.21 1.294 3.133 1.352 4.401.139l.137-.139 3.272-3.498c.258-.275.658-.275.915 0 .219.234.25.575.073.852l-.073.093-3.272 3.498c-.859.92-1.984 1.424-3.16 1.424-1.19 0-2.358-.515-3.208-1.424-1.706-1.824-1.774-4.738-.156-6.604l.156-.171 3.272-3.499c1.775-1.898 4.642-1.898 6.37.001zm7.713-6.88c1.698 1.824 1.766 4.738.155 6.604l-.155.17-3.258 3.5c-.862.924-1.984 1.423-3.195 1.423-1.185 0-2.347-.515-3.194-1.424-.25-.269-.25-.675 0-.944.257-.276.656-.276.913 0 1.204 1.293 3.117 1.351 4.38.138l.136-.138 3.258-3.499c1.26-1.353 1.26-3.532 0-4.886-1.204-1.293-3.118-1.352-4.38-.138l-.137.138-3.257 3.498c-.257.276-.656.276-.913 0-.218-.233-.248-.574-.072-.851l.072-.093 3.257-3.498c1.768-1.899 4.622-1.899 6.39 0z"
      />
    </g>
  </svg>
);

Contents.defaultProps = {
  ariaLabel: '',
};

Contents.propTypes = {
  ariaLabel: PropTypes.string,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default Contents;
